import Image, { ImageProps } from 'next/image';
import { css } from '@emotion/react';

import imageLoader from '../../utils/image-loader';

const imageDisSelectStyle = css`
  user-select: none;
  -webkit-user-drag: none;
`;

interface Props extends ImageProps {
  disableImageDrag?: boolean;
}

const NextImage = (props: Props) => {
  const { disableImageDrag, ...otherProps } = props;
  return <Image {...otherProps} loader={imageLoader} css={disableImageDrag ? imageDisSelectStyle : {}} />;
};

export default NextImage;
